import type { TableSelectedCell } from '@/components/custom/erp';
import type { ChiTietPhieuXuatKho } from '@/types/schemas';
import { useTableRows } from '@/components/custom/erp';

export type SelectedCellInfo = TableSelectedCell;

export type DetailRow = ChiTietPhieuXuatKho & { uuid: string };

export function useDetailRows(
  initialRows: DetailRow[] = [],
  onChange?: (rows: DetailRow[]) => void,
  onFieldValueChange?: (row: DetailRow, field: string, value: unknown) => Partial<DetailRow>
) {
  const {
    rows,
    setRows,
    selectedRowUuid,
    setSelectedRowUuid,
    selectedRow,
    setSelectedRow,
    selectedCell,
    setSelectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handleMoveRow,
    handlePasteRow,
    setNonWritableFields,
    setPasteConfigs
  } = useTableRows<DetailRow>({
    initialRows,
    defaultRows: 1,
    onChange,
    onFieldValueChange,
    defaultField: 'ma_vt'
  });

  return {
    rows,
    setRows,
    selectedRowUuid,
    setSelectedRowUuid,
    selectedRow,
    setSelectedRow,
    selectedCell,
    setSelectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    setNonWritableFields,
    setPasteConfigs
  };
}
